/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_FachschaftInputs */

const en__field_fachschaft = /** @type {(inputs: _Field_FachschaftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fachschaft`)
};

const de__field_fachschaft = /** @type {(inputs: _Field_FachschaftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fachschaft`)
};

/**
* | output |
* | --- |
* | "Fachschaft" |
*
* @param {_Field_FachschaftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_fachschaft = /** @type {((inputs?: _Field_FachschaftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_FachschaftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_fachschaft(inputs)
	return de__field_fachschaft(inputs)
});